import * as React from "react";
import { useTranslation } from "react-i18next";

import styles from "./BurnoutCompensation.module.scss";

import { stressCompensationArrows, stressCompensationMan } from "assets/image";

const BurnoutCompensation = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.title}>
        <img
          className={styles.titleImage}
          src={stressCompensationArrows}
          alt="Head"
        />
        {t("Docs.BurnoutCompensation.Title")}
      </div>
      <div className={styles.blockContainer}>
        <div className={styles.column}>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutCompensation.Blocks.Block1.TextBlue")}
            </span>
            {t("Docs.BurnoutCompensation.Blocks.Block1.Text")}
          </div>
          <div className={styles.text}>
            {t("Docs.BurnoutCompensation.Blocks.Block2.Text")}
            <span className={styles.text_blue}>
              {t("Docs.BurnoutCompensation.Blocks.Block2.TextBlue")}
            </span>
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutCompensation.Blocks.Block3.TextBlue")}
            </span>
            {t("Docs.BurnoutCompensation.Blocks.Block3.Text")}
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutCompensation.Blocks.Block4.TextBlue")}
            </span>
            {t("Docs.BurnoutCompensation.Blocks.Block4.Text")}
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.BurnoutCompensation.Blocks.Block5.TextBlue")}
            </span>
            {t("Docs.BurnoutCompensation.Blocks.Block5.Text")}
          </div>
        </div>
      </div>
      <div className={styles.imageContainer}>
        <img
          className={styles.image}
          src={stressCompensationMan}
          alt="sad man"
        />
      </div>
    </div>
  );
};

export default BurnoutCompensation;
